// import { Bridge } from '@daangn/webview-bridge-modern';
import { installKarrotBridgeDriver, makeKarrotBridge } from "@daangn/karrotbridge";

const { driver } = installKarrotBridgeDriver();
export const bridge = makeKarrotBridge({ driver });

// export const deprecatedBridge = new Bridge();
